import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { activeReportingTelegramGroupAtom } from '../../atoms/reatom-report-telegram-group'
import { reportUserFlowAtom } from '../../atoms/reatom-report-user-flow'

import { ReportTelegramGroupDialog } from './report-telegram-group-dialog'
import { ReportUserDialog } from './report-user-dialog'

type Props = {}

export const ReportDialogsController: React.FC<Props> = () => {
  const [groupToReport, setGroupToReport] = useAtom(
    activeReportingTelegramGroupAtom,
  )
  const [userToReport, setUserToReport] = useAtom(reportUserFlowAtom)

  return (
    <>
      <AnimatePresence>
        {groupToReport ? (
          <ReportTelegramGroupDialog
            open={!!groupToReport}
            onOpenChange={() => setGroupToReport(undefined)}
            groupInfo={groupToReport}
          />
        ) : undefined}
      </AnimatePresence>
      <AnimatePresence>
        {userToReport ? (
          <ReportUserDialog
            open={!!userToReport}
            onOpenChange={() => setUserToReport(undefined)}
            user={userToReport.user}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}
